import React from 'react'

import { Box } from '@vp/swan'

import { useQuantity } from '../../contexts/QuantityContext'
import { PricingSummary } from './PricingSummary'

const QuantityPrice: React.FC = () => {
  const { totalQuantity } = useQuantity()

  return (
    <Box className="qsp-project-quantity-section qsp-project-quantity-section-price" mb="between-subsections" mt="auto">
      <PricingSummary totalQuantity={totalQuantity} />
    </Box>
  )
}

export default QuantityPrice
